export const ArrayListasDesplegables = {
  TIPOS_DE_PROCESOS: [
    {
      Id: 1,
      Nombre: "EJECUTIVO SINGULAR DE MAYOR CUANTÍA",
    },
    {
      Id: 2,
      Nombre: "EJECUTIVO SINGULAR DE MENOR CUANTÍA",
    },
    {
      Id: 3,
      Nombre: "EJECUTIVO SINGULAR DE MÍNIMA CUANTÍA",
    },
    {
      Id: 4,
      Nombre: "EJECUTIVO CON ACCIÓN REAL Y PERSONAL DE MAYOR CUANTÍA",
    },
    {
      Id: 5,
      Nombre: "EJECUTIVO CON ACCIÓN REAL Y PERSONAL DE MENOR CUANTÍA",
    },
    {
      Id: 6,
      Nombre: "EJECUTIVO CON ACCIÓN REAL Y PERSONAL DE MÍNIMA CUANTÍA",
    },
    {
      Id: 7,
      Nombre: "EJECUTIVO PRENDARIO DE MAYOR CUANTÍA",
    },
    {
      Id: 8,
      Nombre: "EJECUTIVO PRENDARIO DE MENOR CUANTÍA",
    },
    {
      Id: 9,
      Nombre: "EJECUTIVO PRENDARIO DE MÍNIMA CUANTÍA",
    },
    {
      Id: 10,
      Nombre: "EJECUTIVO MIXTO DE MAYOR CUANTÍA",
    },
    {
      Id: 11,
      Nombre: "EJECUTIVO MIXTO DE MENOR CUANTÍA",
    },
    {
      Id: 12,
      Nombre: "EJECUTIVO MIXTO DE MÍNIMA CUANTÍA",
    },
    {
      Id: 13,
      Nombre: "PROCESO DE APREHENSIÓN POR PAGO DIRECTO",
    },
    {
      Id: 14,
      Nombre: "PROCESO DE RESTITUCIÓN DE BIEN MUEBLE",
    },
    {
      Id: 15,
      Nombre: "PROCESO DE RESTITUCIÓN DE BIEN INMUEBLE",
    },

    {
      Id: 16,
      Nombre: "DECLARATIVO VERBAL DE MAYOR CUANTÍA",
    },

    {
      Id: 17,
      Nombre: "DECLARATIVO VERBAL DE MENOR CUANTÍA",
    },
    {
      Id: 18,
      Nombre: "DECLARATIVO VERBAL DE MÍNIMA CUANTÍA",
    },
    {
      Id: 19,
      Nombre: "EJECUTIVO HIPOTECARIO DE MAYOR CUANTÍA",
    },
    {
      Id: 20,
      Nombre: "EJECUTIVO HIPOTECARIO DE MENOR CUANTÍA",
    },
    {
      Id: 21,
      Nombre: "EJECUTIVO HIPOTECARIO DE MÍNIMA CUANTÍA",
    },
    {
      Id: 22,
      Nombre: "CURADURÍA",
    },
    {
      Id: 23,
      Nombre: "INSOLVENCIA PERSONA NATURAL NO COMERCIANTE",
    },
    {
      Id: 24,
      Nombre: "INSOLVENCIA EMPRESARIAL O COMERCIAL",
    },
    {
      Id: 25,
      Nombre: "LIQUIDACIÓN PATRIMONIAL",
    },
  ],
  ETAPA_PROCESAL: [
    {
      Id: 1,
      Nombre: "ADMITE DEMANDA",
    },
    {
      Id: 2,
      Nombre: "DICTA SENTENCIA FAVORABLE",
    },
    {
      Id: 3,
      Nombre: "DICTA SENTENCIA DESFAVORABLE",
    },
    {
      Id: 4,
      Nombre: "INADMISIÓN DE LA DEMANDA",
    },
    {
      Id: 5,
      Nombre: "LIQUIDACIÓN APROBADA",
    },
    {
      Id: 6,
      Nombre: "PRESENTACIÓN DE LA DEMANDA",
    },
    {
      Id: 7,
      Nombre: "PRESENTACIÓN DE LIQUIDACIÓN",
    },
    {
      Id: 8,
      Nombre: "ADMITE SOLICITUD DE PAGO DIRECTO",
    },
    {
      Id: 9,
      Nombre: "RECHAZA DEMANDA",
    },
    // {
    //   Id: 10,
    //   Nombre: "APRUEBA LIQUIDACIÓN",
    // },
    {
      Id: 10,
      Nombre: "APROBACIÓN DE LIQUIDACIÓN",
    },
    {
      Id: 11,
      Nombre: "REQUIERE POR NOTIFICACIÓN",
    },
    {
      Id: 12,
      Nombre: "NOTIFICACIÓN ELECTRÓNICA",
    },
    {
      Id: 13,
      Nombre: "NOTIFICACIÓN PERSONAL",
    },
    {
      Id: 14,
      Nombre: "NOTIFICACIÓN POR AVISO",
    },

    {
      Id: 15,
      Nombre: "PLANTEA EXCEPCIONES",
    },
    {
      Id: 16,
      Nombre: "CONTESTA EXCEPCIONES",
    },
    {
      Id: 17,
      Nombre: "EMPLAZAMIENTO",
    },
    {
      Id: 18,
      Nombre: "DESIGNA CURADOR",
    },
    {
      Id: 19,
      Nombre: "LIBRA MANDAMIENTO",
    },
    {
      Id: 20,
      Nombre: "RECHAZA POR COMPETENCIA",
    },
    {
      Id: 21,
      Nombre: "TERMINACIÓN POR PAGO TOTAL",
    },
    {
      Id: 22,
      Nombre: "DESISTIMIENTO TÁCITO",
    },
    {
      Id: 23,
      Nombre: "DEVOLUCIÓN DOCUMENTOS",
    },
    {
      Id: 24,
      Nombre: "TERMINACIÓN POR RESTITUCIÓN DEL PLAZO",
    },
    {
      Id: 25,
      Nombre: "NULIDAD",
    },
    {
      Id: 26,
      Nombre: "RECURSO REPOSICIÓN",
    },
    {
      Id: 27,
      Nombre: "RECURSO APELACIÓN",
    },
    {
      Id: 28,
      Nombre: "OTROS RECURSOS",
    },
    {
      Id: 29,
      Nombre: "NOTIFICACIÓN DE PAGO DIRECTO",
    },
    {
      Id: 30,
      Nombre: "CESIÓN DE DERECHOS",
    },
    {
      Id: 31,
      Nombre: "RENUNCIA AL PODER",
    },
    {
      Id: 32,
      Nombre: "TRASLADO DE LIQUIDACIÓN",
    },
    {
      Id: 33,
      Nombre: "SUBSANACIÓN",
    },
    {
      Id: 34,
      Nombre: "SUSPENSIÓN DE PROCESO",
    },
    {
      Id: 35,
      Nombre: "LIQUIDACIÓN DE COSTAS",
    },
    {
      Id: 36,
      Nombre: "VENTA DE CARTERA",
    },
    {
      Id: 37,
      Nombre: "CONTABILIZACIÓN EN CURSO",
    },
    {
      Id: 38,
      Nombre: "PRESENTACIÓN DE ACREENCIAS",
    },
    {
      Id: 39,
      Nombre: "GRADUACIÓN Y CALIFICACIÓN DE CRÉDITOS",
    },
    {
      Id: 40,
      Nombre: "OBJECIONES",
    },
    {
      Id: 41,
      Nombre: "APROBACIÓN DEL ACUERDO",
    },
    {
      Id: 42,
      Nombre: "CONTROVERSIAS",
    },
    {
      Id: 43,
      Nombre: "FRACASO DEL ACUERDO",
    },

    {
      Id: 44,
      Nombre: "ACTUALIZACIÓN DE BIENES Y AVALÚOS",
    },
    {
      Id: 45,
      Nombre: "PROYECTO DE ADJUDICACIÓN",
    },
    {
      Id: 46,
      Nombre: "AUDIENCIA DE ADJUDICACIÓN",
    },
    {
      Id: 47,
      Nombre: "TERMINACIÓN EN TRÁMITE",
    },
    {
      Id: 48,
      Nombre: "RETIRO DE LA DEMANDA",
    },
    {
      Id: 49,
      Nombre: "INMUEBLE RESTITUIDO O TERMINACIÓN POR RESTITUCIÓN DEL INMUEBLE",
    },
    {
      Id: 50,
      Nombre: "ENVÍO DE DOCUMENTOS PARA PRESENTACIÓN DE DEMANDA",
    },
    {
      Id: 51,
      Nombre: "VENTA POR ALIADO EN CURSO",
    },
    {
      Id: 52,
      Nombre: "FIJA FECHA DE AUDIENCIA",
    },
    {
      Id: 53,
      Nombre: "SUBROGACIÓN DE CRÉDITO",
    },
    {
      Id: 54,
      Nombre: "CORRECCIÓN DE AUTO",
    },
    {
      Id: 55,
      Nombre: "FIJA FECHA PARA DILIGENCIA DE RESTITUCIÓN",
    },
    {
      Id: 56,
      Nombre:
        "TERMINACIÓN DE TRÁMITE DE INSOLVENCIA POR CARENCIA DE BIENES A ADJUDICAR",
    },
    {
      Id: 57,
      Nombre: "FIJA FECHA DE ADJUDICACIÓN",
    },
    {
      Id: 58,
      Nombre: "TRASLADO DE INVENTARIO Y AVALÚOS",
    },
    {
      Id: 59,
      Nombre: "CONTROL DE LEGALIDAD",
    },
    {
      Id: 60,
      Nombre: "CONCILIACIÓN DE OBLIGACIONES",
    },
    {
      Id: 61,
      Nombre: "PROPUESTA DE PAGO",
    },
    {
      Id: 62,
      Nombre: "PRESENTACIÓN DE LIQUIDACIÓN PATRIMONIAL",
    },
    {
      Id: 63,
      Nombre: "EN TRÁMITE DE OBJECIONES",
    },
    {
      Id: 64,
      Nombre: "IMPUGNACIÓN",
    },
    {
      Id: 65,
      Nombre: "ADJUDICACIÓN EFECTIVA POR LIQUIDACIÓN PATRIMONIAL",
    },
  ],
  FACTURA_AVANCE_PROCESAL: [
    {
      Id: 1,
      Nombre: "MANDAMIENTO",
    },
    {
      Id: 2,
      Nombre: "SENTENCIA",
    },
  ],
  PAGO_AVANCE_PROCESAL: [
    {
      Id: 1,
      Nombre: "SENTENCIA",
    },
    {
      Id: 2,
      Nombre: "LIQUIDACIÓN",
    },
  ],
  NEGOCIACION: [
    {
      Id: 1,
      Nombre: "CUMPLIÓ ACUERDO",
    },
    {
      Id: 2,
      Nombre: "EN CUMPLIMIENTO",
    },
    {
      Id: 3,
      Nombre: "ACUERDO INCUMPLIDO",
    },
    {
      Id: 4,
      Nombre: "SIN ACUERDO",
    },
  ],
  ETAPA_PROCESAL_MEDIDAS: [
    {
      Id: 1,
      Nombre: "SOLICITUD DE EMBARGO VEHÍCULO",
    },
    {
      Id: 2,
      Nombre: "SOLICITUD DE EMBARGO INMUEBLE",
    },
    {
      Id: 3,
      Nombre: "SOLICITUD DE EMBARGO ESTABLECIMIENTO",
    },
    {
      Id: 4,
      Nombre: "SOLICITUD DE EMBARGO INNOMINADA",
    },
    {
      Id: 5,
      Nombre: "DECRETO DE EMBARGO VEHÍCULO",
    },
    {
      Id: 6,
      Nombre: "DECRETO DE EMBARGO INMUEBLE",
    },
    {
      Id: 7,
      Nombre: "DECRETO DE EMBARGO ESTABLECIMIENTO",
    },
    {
      Id: 8,
      Nombre: "DECRETO DE EMBARGO INNOMINADA",
    },
    {
      Id: 9,
      Nombre: "ELABORA OFICIOS",
    },
    {
      Id: 10,
      Nombre: "RADICA OFICIOS",
    },
    {
      Id: 11,
      Nombre: "DECRETA ORDEN DE RETENCIÓN",
    },
    {
      Id: 12,
      Nombre: "RADICA OFICIO DE RETENCIÓN",
    },
    {
      Id: 13,
      Nombre: "ORDENA SECUESTRO",
    },
    {
      Id: 14,
      Nombre: "PRÁCTICA DE SECUESTRO",
    },
    {
      Id: 15,
      Nombre: "PAGO DE DERECHOS DE EMBARGO",
    },
    {
      Id: 16,
      Nombre: "PROFIERE DESPACHO COMISORIO",
    },
    {
      Id: 17,
      Nombre: "RADICA DESPACHO COMISORIO",
    },
    {
      Id: 18,
      Nombre: "FIJA FECHA DE SECUESTRO",
    },
    {
      Id: 19,
      Nombre: "AVALÚO",
    },
    {
      Id: 20,
      Nombre: "REMATE",
    },
    {
      Id: 21,
      Nombre: "LEVANTAMIENTO DE ORDEN DE RETENCIÓN",
    },
    {
      Id: 22,
      Nombre: "EMBARGO DE SALARIO",
    },
  ],
  OPCIONES_SI_NO: [
    {
      Id: 1,
      Nombre: "SI",
    },
    {
      Id: 2,
      Nombre: "NO",
    },
  ],
  OPCIONES_POSITIVO_NEGATIVO: [
    {
      Id: 1,
      Nombre: "POSITIVO",
    },
    {
      Id: 2,
      Nombre: "NEGATIVO",
    },
  ],
  TIPO_DE_BIEN: [
    {
      Id: 1,
      Nombre: "VEHÍCULO",
    },
    {
      Id: 2,
      Nombre: "INMUEBLE",
    },
    {
      Id: 2,
      Nombre: "INMUEBLE",
    },
    {
      Id: 3,
      Nombre: "SALARIO",
    },
    {
      Id: 4,
      Nombre: "CUENTAS",
    },
    {
      Id: 5,
      Nombre: "ACCIONES, CUOTAS PARTES",
    },
    {
      Id: 6,
      Nombre: "ESTABLECIMIENTO DE COMERCIO",
    },
    {
      Id: 7,
      Nombre: "INNOMINADA",
    },
    {
      Id: 8,
      Nombre: "VARIOS",
    },
  ],
  FONDOS: [
    {
      Id: 1,
      Nombre: "FAG",
    },
    {
      Id: 2,
      Nombre: "FNG",
    },
    {
      Id: 3,
      Nombre: "N/A",
    },
  ],

  ABOGADO_ASIGNADO: [
    {
      Id: 1,
      Nombre: "ABOGADO 1",
    },
    {
      Id: 2,
      Nombre: "ABOGADO 2",
    },
    {
      Id: 3,
      Nombre: "ABOGADO 3",
    },
    {
      Id: 4,
      Nombre: "ABOGADO INSOLVENCIA 1",
    },
    {
      Id: 5,
      Nombre: "ABOGADO INSOLVENCIA 2",
    },
    {
      Id: 6,
      Nombre: "ABOGADO INSOLVENCIA 3",
    },
  ],
};
